import { dateConfig } from "config";
import moment from "moment";
import { ARCHIVE, KEY_DATE_FORMAT, PENDING_I18N } from "config/CONSTANTS";
import { getDurationInHours } from "utils";

/**
 * function to process the incomplete workday entry.
 * This function will:
 * 1. calculate duration and hours completed.
 * 2. update if the entry is already approved.
 *
 * @param {object} workEntry
 * @returns {object} workEntry
 */
const processEntry = (workEntry) => {
  let durationInHrs = 0;
  let isException = false;
  let approvedStatus = false;
  let isIncomplete = false;
  try {
    const exceptionRecords = workEntry.punches.filter((record) => {
      if (
        record.inLocalTS &&
        record.inLocalTS !== "" &&
        record.outLocalTS &&
        record.outLocalTS !== ""
      ) {
        let hours = getDurationInHours(record);
        durationInHrs += parseFloat(hours);
        if (durationInHrs > 24) {
          isException = true;
        }
        
      } else if (record.inLocalTS &&
        record.inLocalTS !== "" &&
        (!record.outLocalTS || (record.outLocalTS &&
        record.outLocalTS === ""))) {
          isIncomplete = true;
      } else
      return record;
    });
    console.log("exceptionRecords: ", exceptionRecords);
    if (!isException && exceptionRecords.length > 0) {
      isException =
        moment(new Date()).diff(moment(exceptionRecords[0].inLocalTS), "minutes") /
          60 >
        24
          ? true
          : false;
    }
  } catch (err) {
    console.error("Error in duration calculation: ", err);
  }

   // If even a single record is newly added, 	
  //the status of that whole day even previously being approved will be Pending.	
  approvedStatus =	
    workEntry.punches.filter(	
      (record) => "new" === record.status.toLowerCase()	
    ).length > 0	
      ? false	
      :(workEntry.punches.filter(	
        (record) => "edit" === record.status.toLowerCase()	
      ).length > 0)	
      ? false	
      : true;	

  //workEntry.durationInMins = parseInt(durationInMins);
  // workEntry.hours = `${String(Math.floor(durationInMins / 60)).padStart(
  //   2,
  //   "0"
  // )}.${String(durationInMins % 60).padStart(2, "0")}`;
  workEntry.durationInHrs = durationInHrs.toFixed(2);
  workEntry.isApproved = approvedStatus;

  workEntry.status = isIncomplete
    ? "pgReview.tableStaticText.incomplete"
    : isException
    ? "pgReview.tableStaticText.exception"
    : approvedStatus
    ? "pgReview.tableStaticText.approved"
    // : "pgReview.tableStaticText.pending";
    : PENDING_I18N;

  console.log("PROCESSED ENTRY===", workEntry);
  return workEntry;
};

// Helper function to created new placeholder entry.
const createNewEntry = (workEntry, id) => {
  if (workEntry) {
    return {
      id: id || workEntry.id,
      worker: workEntry.workerId,
      durationInMins: 0,
      hours: "0.0",
      day: moment(workEntry.inLocalTS).format(dateConfig.format5), // "Mon, Jun 01"
      isApproved: false, // used for checkbox
      status: "",
      punches: [],
    };
  }
  return null;
};

/**
 * Function to process the list of punch records and return an array of objects to pair
 * ALGORITHM: (01-oct-2020: OUT time will be available in the punch records)
 * get a list of all punch records ordered by timestamp.
 * filter for any 'archive' records.
 * create a placeholder for 'result' and a new entry as 'tempEntry'.
 * add an empty array 'punches' as an attribute to tempEntry.
 *
 * Loop through all the punch records (already in ascending order by DateTime) to process each item:
 * If result has key with Item.inTime Date,
 *  Then add Item in that result entry
 * Else,
 *  create new entry in result with Item's inTime Date.
 *  & add Item in that result entry
 *
 * Loop through all the result entries to process each entry:
 * Update entry for duration, hours, status and isApproved.
 *
 * @param {array} array of punch records received from db
 * @returns {array} array of entries for rendering on review screen
 */
export const createReviewData = (dbRecords) => {
  console.log("Punch records sorted by inLocalTS: dbRecords=", dbRecords);
  dbRecords = dbRecords.filter(record => record.status.toLowerCase() !== ARCHIVE);

  let result = [];
  let tempEntry = {};

  {
    dbRecords.map((item, idx) => {
      let keyDate = moment(item.inLocalTS).format(KEY_DATE_FORMAT);
      console.log("keyDate: ", keyDate);

      if (result.some((e) => e.id === keyDate)) {
        result.map((obj) => {
          if (obj.id == keyDate) obj.punches.push(item);
        });
      } else {
        tempEntry = createNewEntry(item, keyDate);
        tempEntry.punches.push(item);
        result.push(tempEntry);
      }
    });

    console.log("b4 process===", result);

    result.map((item, idx) => {
      item = processEntry(item);
    });
  }
  console.log("NEW result===", result);
  return result;
};



export const filterEditablePunches = (punches) => {
  punches = punches.filter(record => record.status.toLowerCase() !== ARCHIVE);

  let result = [];

  {
    punches.map((item, idx) => {
      const startDate = moment().subtract(2, 'weeks').startOf('week').format("YYYY-MM-DD");
      const endDate = moment().add(2, 'weeks').startOf('week').format("YYYY-MM-DD");
      let punchInRecordDate = moment(item.id).format("YYYY-MM-DD");
      if(item.nonEditable && item.nonEditable === true) item.editable=false;
      else{
        if (moment(punchInRecordDate).isBetween(startDate,endDate) || moment(punchInRecordDate).isSame(startDate) || moment(punchInRecordDate).isSame(endDate)) 
        { 
          item.editable=true;
        }else  item.editable=false;
      }
        
    });
     
  }
  return punches;
};
